/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 16.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import DataProvider from "../../DataProvider";
import DataTable from "../../pages/Resource/DataTable/DataTable";
import Schema from "../../Schema";
import {t} from "../../trans";

/**
 * Kuvab auditTrail muudatuste info. Kasutamine:
 * "oldValue": {
 *  "ui:widget": "viewChangeInfo"
 * }
 */
class ViewChangeInfo extends React.Component {
    static propTypes = {
        dataProvider: PropTypes.instanceOf(DataProvider).isRequired,
        field: PropTypes.string.isRequired
    };

    static defaultProps = {
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    getData() {
        let unparsedOldValue = this.props.dataProvider.getProvider(this.props.field).getData();
        let newField = this.props.field.replace("oldValue", "newValue");
        let unparsedNewValue = this.props.dataProvider.getProvider(newField).getData();

        let oldValue = JSON.parse(unparsedOldValue);
        let newValue = JSON.parse(unparsedNewValue);

        let data = [];
        let fields = _.keys(oldValue).sort();
        for (let f of fields) {
            data.push({
                field: f,
                oldValue: String(oldValue != null ? oldValue[f] : ""),
                newValue: String(newValue != null ? newValue[f] : "")
            });
        }
        return data;
    }

    getSchema() {
        let jsonSchema = {
            type: "object",
            properties: {
                field: {
                    title: t("Field"),
                    type: "string"
                },
                oldValue: {
                    title: t("Old value"),
                    type: "string"
                },
                newValue: {
                    title: t("New value"),
                    type: "string"
                }
            }
        };
        let uiSchema = {};
        let rec = this.props.dataProvider.getData();
        switch (rec.action) {
            case "D":
                uiSchema["ui:order"] = ["field", "oldValue"];
                jsonSchema.properties.oldValue.title = t("Value");
                break;
            case "I":
                uiSchema["ui:order"] = ["field", "newValue"];
                jsonSchema.properties.newValue.title = t("Value");
                break;
            default:
                uiSchema["ui:order"] = ["field", "oldValue", "newValue"];
                break;
        }
        return new Schema(Schema.createArrayJsonSchema(jsonSchema), {"*":uiSchema}, null);
    }

    render() {
        let schema = this.getSchema();
        let data = this.getData();


        return (
            <DataTable
                schema={schema}
                data={data}
                pageSize={0}
                size="small"
                hideRecColumn={true}
                internalSort={true}
                className="table-responsive"
            />
        );
    }
}

export default ViewChangeInfo;
